import { StyledTimeContainer, StyledTimeLabelContainer, StyledTimeLine, StyledTimeLinesContainer } from "../StyledComponents";

const timelineHours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0') + ':00' );

const DiaryEntryRuler: React.FC = () => {
  return(
    <>
      {/* Timeline numbers (horizontal) */}
      <StyledTimeLabelContainer id='time'>
        {timelineHours.map((hour) => (
          <StyledTimeContainer key={hour}>{hour}</StyledTimeContainer>
        ))}
      </StyledTimeLabelContainer>

      {/* Vertical hour-lines spanning the calendar area */}
      <StyledTimeLinesContainer id='timeline'>
        {timelineHours.map((hour) => (
          <StyledTimeLine key={`line-${hour}`} hour={hour}/>
        ))}
      </StyledTimeLinesContainer>
    </>
  )
}

export default DiaryEntryRuler
